/*
 * ----------------------------------------------------------------------------------------------
 * This is an auto-generated file
 * To update from db, use: 'npm run dblookup' to execute the DBEnumGenerator console project.
 * ----------------------------------------------------------------------------------------------
 */

// #region ChangeLogType (Table: Assist.RepairShopMetaDataType)

export enum ChangeLogType {
/** DisplayName: Namn */
  RepairShopName = 1,
/** DisplayName: Adress */
  YardAddress = 2,
/** DisplayName: Postort */
  YardCity = 3,
/** DisplayName: Postkod */
  YardZip = 4,
/** DisplayName: Lås */
  LockInfoLegacy = 5,
/** DisplayName: Larm */
  AlarmInfoLegacy = 6,
/** DisplayName: Larmkod */
  PassCodeInfoLegacy = 7,
/** DisplayName: Övrigt */
  OtherLegacy = 8,
/** DisplayName: Telefonnummer */
  PhoneNumberLegacy = 9,
/** DisplayName: Faxnummer */
  FaxNumberLegacy = 10,
/** DisplayName: E-postadress */
  EmailLegacy = 11,
/** DisplayName: Kontaktperson */
  ContactPersonLegacy = 12,
/** DisplayName: Mobiltelefon */
  MobileNumberLegacy = 13,
/** DisplayName: Kommentar */
  CommentLegacy = 14,
/** DisplayName: Verkstadstyp */
  SpecialityLegacy = 15,
/** DisplayName: Hemsida */
  WebsiteLegacy = 16,
/** DisplayName: Företagskedja */
  OutletChainLegacy = 17,
/** DisplayName: Bilmärke */
  CarBrand = 18,
/** DisplayName: Försäkringsbolag */
  InsuranceCompany = 19,
/** DisplayName: Vagnskadegaranti */
  CarBrandWarranty = 20,
/** DisplayName: Auktoriserad */
  CarBrandAuthorized = 21,
/** DisplayName: Status */
  Status = 23,
/** DisplayName: Granskad */
  Reviewed = 24,
/** DisplayName: Verkstadstyp */
  Department = 25,
/** DisplayName: Latitud */
  Latitude = 26,
/** DisplayName: Longitud */
  Longitude = 27,
/** DisplayName: Försäkringsbolag */
  InsuranceCompanyActiveLegacy = 28,
/** DisplayName: Intern försäkringsinfo */
  InsuranceCompanyInfoLegacy = 29,
/** DisplayName: Extern bilmärkesinfo */
  ExternalCarBrandInfo = 30,
/** DisplayName: Informationstyp */
  InfoText = 31,
/** DisplayName: Infotext */
  InfoTextValue = 32,
/** DisplayName: Tillagd */
  ModelAdded = 33,
/** DisplayName: Borttagen */
  ModelRemoved = 34,
/** DisplayName: Extern allmän info */
  ExternalGeneralInfo = 35,
/** DisplayName: Externt verkstads-id */
  ExternalRepairShopID = 36,
/** DisplayName: Extern försäkringskoppling */
  ExternalInsuranceCompany = 37,
/** DisplayName: Prioriterad info */
  InfoIsPrioritized = 38,
/** DisplayName: Allbil motor */
  InsuranceAllBrandsEngine = 39,
/** DisplayName: Allbil plåt */
  InsuranceAllBrandsPlate = 40,
/** DisplayName: Aktiv extern koppling */
  ExternalIsActive = 41,
};

// #endregion

// #region DepartmentType (Table: Assist.RepairShopDepartmentType)

export enum DepartmentType {
/** DisplayName: Motor */
  Engine = 1,
/** DisplayName: Plåt */
  Plate = 3,
/** DisplayName: Glas */
  Glass = 4,
/** DisplayName: Bärgargård (inaktiv) */
  SalvageYard = 5,
/** DisplayName: Skrot */
  Dump = 6,
/** DisplayName: Tunga fordon */
  HeavyVehicles = 7,
/** DisplayName: Däck */
  Tire = 8,
/** DisplayName: Övrigt (inaktiv) */
  Other = 9,
/** DisplayName: MC */
  MotorCycle = 10,
/** DisplayName: DäckJour */
  TireOnCall = 11,
/** DisplayName: Trafikverket */
  TransportAgencyTrv = 12,
};

// #endregion

// #region InfoTextType (Table: Assist.RepairShopInfoType)

export enum InfoTextType {
/** DisplayName: Lås */
  LockInfo = 1,
/** DisplayName: Larm */
  AlarmInfo = 2,
/** DisplayName: Kod */
  PassCode = 3,
/** DisplayName: Övrigt (inaktiv) */
  Other = 4,
/** DisplayName: Telefon */
  PhoneNumber = 5,
/** DisplayName: Fax (inaktiv) */
  FaxNumber = 6,
/** DisplayName: E-post */
  Email = 7,
/** DisplayName: Kontaktperson (inaktiv) */
  ContactPerson = 8,
/** DisplayName: Mobilnummer (inaktiv) */
  MobilePhoneNumber = 9,
/** DisplayName: Kommentar */
  Comment = 10,
/** DisplayName: Specialitet (inaktiv) */
  Speciality = 11,
/** DisplayName: Webbsida */
  Website = 12,
/** DisplayName: Kedja (inaktiv) */
  OutletChain = 13,
/** DisplayName: Intern försäkringsinfo */
  InsuranceInfo = 14,
/** DisplayName: Semestertider */
  VacationDates = 15,
};

// #endregion

// #region InsuranceCompanyType (Table: Assist.RepairShopInsuranceCompany)

export enum InsuranceCompanyType {
/** DisplayName: Folksam */
  Folksam = 2,
/** DisplayName: Moderna */
  Moderna = 9,
/** DisplayName: Dina Försäkringar */
  DinaForsakringar = 21,
/** DisplayName: Gjensidige */
  Gjensidige = 27,
/** DisplayName: Länsförsäkringar */
  Lansforsakringar = 45,
/** DisplayName: Svedea */
  Svedea = 119,
/** DisplayName: Protector */
  Protector = 123,
/** DisplayName: IF */
  IF = 133,
/** DisplayName: Trygg Hansa */
  TryggHansa = 134,
/** DisplayName: Solid Försäkring */
  SolidForsakring = 147,
/** DisplayName: ICA Försäkring */
  ICAForsakring = 150,
/** DisplayName: Midland */
  Midland = 199,
/** DisplayName: Eir Försäkring */
  EirForsakring = 207,
};

// #endregion

// #region StatusType (Table: Assist.RepairShopStatus)

export enum StatusType {
/** DisplayName: Dubblett */
  Duplicate = 1,
/** DisplayName: Borttagen */
  Removed = 2,
/** DisplayName: Ogranskad */
  NotReviewed = 3,
/** DisplayName: Aktiv */
  Reviewed = 4,
/** DisplayName: ProposedRemove */
  ProposedRemove = 5,
/** DisplayName: ProposedDuplicate */
  ProposedDuplicate = 6,
};

// #endregion

// #region displayName lookup maps

const displayNamesByChangeLogType = new Map([
  [ChangeLogType.RepairShopName, 'Namn'],
  [ChangeLogType.YardAddress, 'Adress'],
  [ChangeLogType.YardCity, 'Postort'],
  [ChangeLogType.YardZip, 'Postkod'],
  [ChangeLogType.LockInfoLegacy, 'Lås'],
  [ChangeLogType.AlarmInfoLegacy, 'Larm'],
  [ChangeLogType.PassCodeInfoLegacy, 'Larmkod'],
  [ChangeLogType.OtherLegacy, 'Övrigt'],
  [ChangeLogType.PhoneNumberLegacy, 'Telefonnummer'],
  [ChangeLogType.FaxNumberLegacy, 'Faxnummer'],
  [ChangeLogType.EmailLegacy, 'E-postadress'],
  [ChangeLogType.ContactPersonLegacy, 'Kontaktperson'],
  [ChangeLogType.MobileNumberLegacy, 'Mobiltelefon'],
  [ChangeLogType.CommentLegacy, 'Kommentar'],
  [ChangeLogType.SpecialityLegacy, 'Verkstadstyp'],
  [ChangeLogType.WebsiteLegacy, 'Hemsida'],
  [ChangeLogType.OutletChainLegacy, 'Företagskedja'],
  [ChangeLogType.CarBrand, 'Bilmärke'],
  [ChangeLogType.InsuranceCompany, 'Försäkringsbolag'],
  [ChangeLogType.CarBrandWarranty, 'Vagnskadegaranti'],
  [ChangeLogType.CarBrandAuthorized, 'Auktoriserad'],
  [ChangeLogType.Status, 'Status'],
  [ChangeLogType.Reviewed, 'Granskad'],
  [ChangeLogType.Department, 'Verkstadstyp'],
  [ChangeLogType.Latitude, 'Latitud'],
  [ChangeLogType.Longitude, 'Longitud'],
  [ChangeLogType.InsuranceCompanyActiveLegacy, 'Försäkringsbolag'],
  [ChangeLogType.InsuranceCompanyInfoLegacy, 'Intern försäkringsinfo'],
  [ChangeLogType.ExternalCarBrandInfo, 'Extern bilmärkesinfo'],
  [ChangeLogType.InfoText, 'Informationstyp'],
  [ChangeLogType.InfoTextValue, 'Infotext'],
  [ChangeLogType.ModelAdded, 'Tillagd'],
  [ChangeLogType.ModelRemoved, 'Borttagen'],
  [ChangeLogType.ExternalGeneralInfo, 'Extern allmän info'],
  [ChangeLogType.ExternalRepairShopID, 'Externt verkstads-id'],
  [ChangeLogType.ExternalInsuranceCompany, 'Extern försäkringskoppling'],
  [ChangeLogType.InfoIsPrioritized, 'Prioriterad info'],
  [ChangeLogType.InsuranceAllBrandsEngine, 'Allbil motor'],
  [ChangeLogType.InsuranceAllBrandsPlate, 'Allbil plåt'],
  [ChangeLogType.ExternalIsActive, 'Aktiv extern koppling'],
]);

const displayNamesByDepartmentType = new Map([
  [DepartmentType.Engine, 'Motor'],
  [DepartmentType.Plate, 'Plåt'],
  [DepartmentType.Glass, 'Glas'],
  [DepartmentType.SalvageYard, 'Bärgargård (inaktiv)'],
  [DepartmentType.Dump, 'Skrot'],
  [DepartmentType.HeavyVehicles, 'Tunga fordon'],
  [DepartmentType.Tire, 'Däck'],
  [DepartmentType.Other, 'Övrigt (inaktiv)'],
  [DepartmentType.MotorCycle, 'MC'],
  [DepartmentType.TireOnCall, 'DäckJour'],
  [DepartmentType.TransportAgencyTrv, 'Trafikverket'],
]);

const displayNamesByInfoTextType = new Map([
  [InfoTextType.LockInfo, 'Lås'],
  [InfoTextType.AlarmInfo, 'Larm'],
  [InfoTextType.PassCode, 'Kod'],
  [InfoTextType.Other, 'Övrigt (inaktiv)'],
  [InfoTextType.PhoneNumber, 'Telefon'],
  [InfoTextType.FaxNumber, 'Fax (inaktiv)'],
  [InfoTextType.Email, 'E-post'],
  [InfoTextType.ContactPerson, 'Kontaktperson (inaktiv)'],
  [InfoTextType.MobilePhoneNumber, 'Mobilnummer (inaktiv)'],
  [InfoTextType.Comment, 'Kommentar'],
  [InfoTextType.Speciality, 'Specialitet (inaktiv)'],
  [InfoTextType.Website, 'Webbsida'],
  [InfoTextType.OutletChain, 'Kedja (inaktiv)'],
  [InfoTextType.InsuranceInfo, 'Intern försäkringsinfo'],
  [InfoTextType.VacationDates, 'Semestertider'],
]);

const displayNamesByInsuranceCompanyType = new Map([
  [InsuranceCompanyType.Folksam, 'Folksam'],
  [InsuranceCompanyType.Moderna, 'Moderna'],
  [InsuranceCompanyType.DinaForsakringar, 'Dina Försäkringar'],
  [InsuranceCompanyType.Gjensidige, 'Gjensidige'],
  [InsuranceCompanyType.Lansforsakringar, 'Länsförsäkringar'],
  [InsuranceCompanyType.Svedea, 'Svedea'],
  [InsuranceCompanyType.Protector, 'Protector'],
  [InsuranceCompanyType.IF, 'IF'],
  [InsuranceCompanyType.TryggHansa, 'Trygg Hansa'],
  [InsuranceCompanyType.SolidForsakring, 'Solid Försäkring'],
  [InsuranceCompanyType.ICAForsakring, 'ICA Försäkring'],
  [InsuranceCompanyType.Midland, 'Midland'],
  [InsuranceCompanyType.EirForsakring, 'Eir Försäkring'],
]);

const displayNamesByStatusType = new Map([
  [StatusType.Duplicate, 'Dubblett'],
  [StatusType.Removed, 'Borttagen'],
  [StatusType.NotReviewed, 'Ogranskad'],
  [StatusType.Reviewed, 'Aktiv'],
  [StatusType.ProposedRemove, 'ProposedRemove'],
  [StatusType.ProposedDuplicate, 'ProposedDuplicate'],
]);

 
// #endregion

// #region Get Display Name Utility Functions

export function getChangeLogTypeDisplayName(id: ChangeLogType): string {
  return displayNamesByChangeLogType.get(id) || '';
}

export function getDepartmentTypeDisplayName(id: DepartmentType): string {
  return displayNamesByDepartmentType.get(id) || '';
}

export function getInfoTextTypeDisplayName(id: InfoTextType): string {
  return displayNamesByInfoTextType.get(id) || '';
}

export function getInsuranceCompanyTypeDisplayName(id: InsuranceCompanyType): string {
  return displayNamesByInsuranceCompanyType.get(id) || '';
}

export function getStatusTypeDisplayName(id: StatusType): string {
  return displayNamesByStatusType.get(id) || '';
}

// #endregion

